import React, { Component } from 'react'

export default class Tooltip extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false,
    }
    this._timer = null
    this.hideElement = this.hideElement.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      this.setState({ show: true })
      if (!this.props.disableTimeout) {
        clearTimeout(this._timer)
        this._timer = setTimeout(this.hideElement, this.props.hidesAfter)
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this._timer)
  }

  hideElement() {
    this.setState({ show: false })
  }

  render() {
    return (
      <div className={this.props.className} style={{ display: this.state.show ? 'block' : 'none' }}>
        {this.props.children}
      </div>
    )
  }
}
